import { z } from "zod";

import { basicsSchema, defaultBasics } from "./basics";

// Schema version — bump this when ResumeData structure changes in a breaking way.
// MCP agents that consume resume JSON must define a matching RESUME_SCHEMA_VERSION constant.
// See ADR-001 Rule 6 and tools/scripts/check-schema-version.mjs for enforcement.
export const RESUME_SCHEMA_VERSION = "1.0.0";
import { defaultMetadata, metadataSchema } from "./metadata";
import { defaultSections, sectionsSchema } from "./sections";

// Cover Letter schema for cover letter documents
export const coverLetterSchema = z.object({
  body: z.string().default(""), // Full cover letter content as single text
  recipientName: z.string().optional(),
  recipientTitle: z.string().optional(),
  companyName: z.string().optional(),
  jobTitle: z.string().optional(),
  tone: z.string().optional(),
  generatedAt: z.string().optional(),
}).optional();

// Schema
export const resumeDataSchema = z.object({
  basics: basicsSchema,
  sections: sectionsSchema,
  metadata: metadataSchema,
  coverLetter: coverLetterSchema,
});

// Type
export type ResumeData = z.infer<typeof resumeDataSchema>;
export type CoverLetterData = z.infer<typeof coverLetterSchema>;

// Defaults
export const defaultResumeData: ResumeData = {
  basics: defaultBasics,
  sections: defaultSections,
  metadata: defaultMetadata,
  coverLetter: undefined,
};

export * from "./basics";
export * from "./metadata";
export * from "./sample";
export * from "./sample-localized";
export * from "./sections";
export * from "./shared";
